import cpSite from './cpSite'

/**
 * Работа Header на главной странице
 */
const quicktabsHeader = {
  state: {
    isActive: false
  },
  activate: function () {
    if (cpSite.config.DEVMODE) {
      console.log('active: quicktabsHeader')
    }

    const client = document.getElementById('quickmenu-client')
    if (!client) {
      return
    }
    const legal = document.getElementById('quickmenu-legal')
    const develop = document.getElementById('quickmenu-develop')
    const leftBlockClient = document.getElementById('leftBlock-client')
    const leftBlockLegal = document.getElementById('leftBlock-legal')
    const leftBlockDevelop = document.getElementById('leftBlock-develop')
    const contColClient = document.getElementById('contCol-client')
    const contColLegal = document.getElementById('contCol-legal')
    const contColDevelop = document.getElementById('contCol-develop')
    const rightColClient = document.getElementById('rightCol-client')
    const rightColLegal = document.getElementById('rightCol-legal')
    const rightColDevelop = document.getElementById('rightCol-develop')

    // Клиентам
    document.getElementById('quickmenu-client').addEventListener('click', function name (params) {
      leftBlockClient.style.display = 'block'
      leftBlockLegal.style.display = 'none'
      leftBlockDevelop.style.display = 'none'

      contColClient.style.display = 'block'
      contColLegal.style.display = 'none'
      contColDevelop.style.display = 'none'

      rightColClient.style.display = 'block'
      rightColLegal.style.display = 'none'
      rightColDevelop.style.display = 'none'

      client.classList.add('active')
      legal.classList.remove('active')
      develop.classList.remove('active')
    })

    // Правовая информация
    document.getElementById('quickmenu-legal').addEventListener('click', function name (params) {
      leftBlockClient.style.display = 'none'
      leftBlockLegal.style.display = 'block'
      leftBlockDevelop.style.display = 'none'

      contColClient.style.display = 'none'
      contColLegal.style.display = 'flex'
      contColDevelop.style.display = 'none'

      rightColClient.style.display = 'none'
      rightColLegal.style.display = 'block'
      rightColDevelop.style.display = 'none'

      client.classList.remove('active')
      legal.classList.add('active')
      develop.classList.remove('active')
    })

    // Разработчикам
    document.getElementById('quickmenu-develop').addEventListener('click', function name (params) {
      leftBlockClient.style.display = 'none'
      leftBlockLegal.style.display = 'none'
      leftBlockDevelop.style.display = 'block'

      contColClient.style.display = 'none'
      contColLegal.style.display = 'none'
      contColDevelop.style.display = 'block'

      rightColClient.style.display = 'none'
      rightColLegal.style.display = 'none'
      rightColDevelop.style.display = 'inline-block'

      client.classList.remove('active')
      legal.classList.remove('active')
      develop.classList.add('active')
    })

    // Запись об активации скрипта
    this.state.isActive = true
  }
}

export default quicktabsHeader
